export const referralOtherValueFormatter = (
  referralType: string,
  referralValue: string,
) => {
  switch (referralType) {
    case 'Employee':
      return 'Employee Name: ' + referralValue
    case 'Other':
      return 'Other Source: ' + referralValue
    case 'None':
      return ''
    default:
      return ''
  }
}

export const referralValueChecker = (
  referralType: string,
  referralTypeToMatch: string,
  referralValue: string,
) => {
  if (!referralType || referralType !== referralTypeToMatch || !referralValue) {
    return ''
  } else return referralValue
}
